import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import localeRU from "../locales/ru/ru.json"
import localeRUClient from "../locales/ru/client.json"
import localeUZ from "../locales/uz/uz.json"
import localeEN from "../locales/en/en.json"

/** Mijoz (Counterparty) kabineti uchun bir nechta atama boshqacha nomlanadi */
const clientOverridesUZ = {
  home: "Tovarlar",
  orders: "Buyurtmalar tarixi",
}
const clientOverridesEN = {
  home: "Products",
  orders: "Order history",
}

const resources = {
  ru: {
    translation: localeRU,
    client: { ...localeRU, ...localeRUClient },
  },
  uz: {
    translation: localeUZ,
    client: { ...localeUZ, ...clientOverridesUZ },
  },
  en: {
    translation: localeEN,
    client: { ...localeEN, ...clientOverridesEN },
  },
}

export const SUPPORTED_LANGUAGES = ["uz", "ru", "en"] as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Tanlangan til localStorage da saqlanadi; birinchi kirishda rus tili
    fallbackLng: "ru",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    nonExplicitSupportedLngs: true,
    saveMissing: true,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  })

i18n.on("missingKey", function (lngs, namespace, key, res) {
  // console.log({ lngs, namespace, key, res })
})

export default i18n
